import { render, staticRenderFns } from "./pricePlanList.vue?vue&type=template&id=5ff9fa0d&scoped=true"
import script from "./pricePlanList.vue?vue&type=script&lang=js"
export * from "./pricePlanList.vue?vue&type=script&lang=js"
import style0 from "./pricePlanList.vue?vue&type=style&index=0&id=5ff9fa0d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9fa0d",
  null
  
)

export default component.exports